import { PushPin, PushPinOutlined } from '@mui/icons-material';
import { styled } from '@mui/material';
import React from 'react';

interface PinContainerProps {
  pinned?: boolean;
  folderPinned?: boolean;
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void;
  iconOnly?: boolean;
}

const StyledPinContainer = styled('div', {
  shouldForwardProp: (prop) => !['pinned', 'folderPinned', 'iconOnly'].includes(prop.toString()),
})<PinContainerProps>(({ pinned, folderPinned, iconOnly }) => {
  const isBothPinned = pinned && folderPinned;
  const isOnlyPinned = pinned && !folderPinned;
  const isOnlyFolderPinned = folderPinned && !pinned;

  return {
    backgroundColor: '#fff',
    color: '#767676',

    // animated gradient background for both pinned
    ...(isBothPinned && {
      background: 'linear-gradient(to right, #38a745, #0047FF)',
      color: 'white',
    }),

    // solid green background for pinned
    ...(isOnlyPinned && {
      backgroundColor: '#d6f5de',
      color: '#0B6E27',
    }),

    // solid blue background for folder pinned
    ...(isOnlyFolderPinned && {
      backgroundColor: '#e0ecff',
      color: '#0047FF',
    }),

    border: pinned || folderPinned ? 'none' : '1px solid #767676',
    height: '18px',
    width: '18px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      width: '12px',
      height: '12px',
    },

    ':hover': !iconOnly
      ? {
          cursor: 'pointer',
          backgroundColor: pinned ? '#9dd1ac' : '#d9d9d9',
        }
      : {},

    '@keyframes gradientShift': {
      '0%': { backgroundPosition: '0% 50%' },
      '50%': { backgroundPosition: '100% 50%' },
      '100%': { backgroundPosition: '0% 50%' },
    },
  };
});

const PinContainer: React.FC<PinContainerProps> = ({ pinned, folderPinned, onClick, iconOnly }) => {
  return (
    <StyledPinContainer
      pinned={pinned}
      folderPinned={folderPinned}
      onClick={onClick}
      iconOnly={iconOnly}
    >
      {pinned || folderPinned ? <PushPin /> : <PushPinOutlined />}
    </StyledPinContainer>
  );
};

export default PinContainer;
